import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=111227f7&scoped=true"
import script from "./ClientDetails.vue?vue&type=script&lang=js"
export * from "./ClientDetails.vue?vue&type=script&lang=js"
import style0 from "./ClientDetails.vue?vue&type=style&index=0&id=111227f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111227f7",
  null
  
)

export default component.exports